import React, {useState} from 'react';
import {IGlobalStorefrontSettings, IStorefrontSettings} from '../../models/Storefront';
import {TextField} from '@fluentui/react';
import StorefrontDomainDropdown from './StorefrontDomainDropdown';
import ToggleField from "../Common/ToggleField";
import CountrySelection from "../CountrySelection/CountrySelection";


interface IStorefrontSettingsFormProps {
    globalSettings?: IGlobalStorefrontSettings;
    settings: IStorefrontSettings;
    onChange: (settings: IStorefrontSettings) => void;
    onLoading?: (isLoading: boolean) => void;
}

const StorefrontBasicSettingsForm: React.FC<IStorefrontSettingsFormProps> = (props) => {
    const [subUrlErrorMessage, setSubUrlErrorMessage] = useState<string | undefined>();

    return (
        <div>
            <h3>Settings</h3>
            <ToggleField inline={true} label='Enabled' checked={props.settings.enabled} onChange={(e, c) => props.onChange({...props.settings, enabled: c})} />
            <TextField label='Sub URL' value={props.settings.subUrl} errorMessage={subUrlErrorMessage} onChange={(e, v) => props.onChange({...props.settings, subUrl: v ?? ''})} />
            <StorefrontDomainDropdown label='Domain' value={props.settings.domain ?? ''} onChange={(v) => props.onChange({...props.settings, domain: v})} />
            <TextField label='Name' value={props.settings.name} onChange={(e, v) => props.onChange({...props.settings, name: v ?? ''})} />
            <CountrySelection value={props.settings.defaultCountry} onChange={(country) => props.onChange({...props.settings, defaultCountry: country})} />

        </div>
    );
}

export default StorefrontBasicSettingsForm;